<script setup>
// Skeleton do painel central de mensagens.
// Layout simula bolhas reais (mesmo raio 15px, mesmo formato com canto
// inferior "cortado") com 1-3 linhas placeholder dentro de cada bolha.
// Shimmer aplicado nas linhas internas, nao no container — efeito sutil.

// Apenas 2 bolhas placeholder no rodape. As 2 sao cinza neutro pra nao
// confundir com bolha de mensagem real (verde/cinza). Cada bolha tem 2
// linhas pra ter "massa visual" semelhante a uma mensagem multi-linha.
const rows = [
  { dir: 'in',  width: 56, lines: [86, 58] },
  { dir: 'out', width: 48, lines: [82, 46] },
];
</script>

<template>
  <div class="sz-mskel" aria-busy="true" aria-label="Carregando mensagens">
    <div
      v-for="(r, i) in rows"
      :key="i"
      class="sz-mskel-row"
      :class="r.dir === 'in' ? 'sz-mskel-row--in' : 'sz-mskel-row--out'"
    >
      <div
        class="sz-mskel-bubble"
        :class="r.dir === 'in' ? 'sz-mskel-bubble--in' : 'sz-mskel-bubble--out'"
        :style="{ width: r.width + '%' }"
      >
        <div
          v-for="(w, j) in r.lines"
          :key="j"
          class="sz-mskel-line sz-mskel-shimmer"
          :style="{ width: w + '%' }"
        ></div>
        <div class="sz-mskel-meta sz-mskel-shimmer"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sz-mskel {
  /* tokens light (default) */
  --sz-mskel-bubble: #E5E7EB;
  --sz-mskel-bubble-out: #E5E7EB;
  --sz-mskel-line: #D5D9DF;
  --sz-mskel-shimmer: rgba(255, 255, 255, 0.55);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 0 16px;
  width: 100%;
  box-sizing: border-box;
}

:global(.dark) .sz-mskel,
.dark .sz-mskel {
  --sz-mskel-bubble: #2A2D33;
  --sz-mskel-bubble-out: #2A2D33;
  --sz-mskel-line: #3A3F47;
  --sz-mskel-shimmer: rgba(255, 255, 255, 0.05);
}

.sz-mskel-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}
.sz-mskel-row--in  { justify-content: flex-start; }
.sz-mskel-row--out { justify-content: flex-end; }

.sz-mskel-bubble {
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 100px;
  background: var(--sz-mskel-bubble);
}
.sz-mskel-bubble--in {
  border-top-left-radius: 0;
}
.sz-mskel-bubble--out {
  background: var(--sz-mskel-bubble-out);
  border-top-right-radius: 0;
}
.sz-mskel-row--out .sz-mskel-bubble {
  align-items: flex-end;
}

.sz-mskel-line {
  height: 9px;
  border-radius: 4px;
  background: var(--sz-mskel-line);
  position: relative;
  overflow: hidden;
}

.sz-mskel-meta {
  height: 7px;
  width: 58px;
  border-radius: 4px;
  background: var(--sz-mskel-line);
  opacity: 0.7;
  align-self: flex-end;
  margin-top: 2px;
  position: relative;
  overflow: hidden;
}

/* Shimmer: faixa clara passando da esquerda pra direita */
.sz-mskel-shimmer::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--sz-mskel-shimmer) 50%,
    transparent 100%
  );
  transform: translateX(-100%);
  animation: sz-mskel-slide 1.5s ease-in-out infinite;
}

@keyframes sz-mskel-slide {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@media (prefers-reduced-motion: reduce) {
  .sz-mskel-shimmer::after { animation: none; }
  .sz-mskel-line { animation: sz-mskel-pulse 1.6s ease-in-out infinite; }
  @keyframes sz-mskel-pulse {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.6; }
  }
}
</style>
